<template>
  <!-- Prova de autoridade / faixa de números (PDF §5, spec §6).
       Números devem ser validados internamente antes de publicar. -->
  <section id="numeros" class="stats">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div
          v-for="(item, i) in itens"
          :key="i"
          class="col-6 col-lg-3 stat-item"
          data-aos="fade-up"
          :data-aos-delay="i * 100"
        >
          <i class="bi stat-icon" :class="item.icone"></i>
          <p class="stat-num">{{ item.numero }}</p>
          <p class="stat-label">{{ item.label }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StatsSection',
  data() {
    return {
      itens: [
        { icone: 'bi-people-fill', numero: '+2.000', label: 'clientes' },
        { icone: 'bi-shield-check', numero: 'Mais segurança', label: 'nas operações' },
        { icone: 'bi-graph-up-arrow', numero: 'Mais vendas', label: 'com menos risco' },
        { icone: 'bi-clock-history', numero: '+20 anos', label: 'de mercado' },
      ],
    };
  },
};
</script>

<style scoped>
.stats {
  padding: 40px 0;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}
.stat-item {
  padding: 16px 8px;
}
.stat-icon {
  font-size: 28px;
  color: #bf1b39;
  display: block;
  margin-bottom: 8px;
}
.stat-num {
  font-size: 22px;
  font-weight: 700;
  color: #191919;
  margin: 0;
  line-height: 1.2;
}
.stat-label {
  font-size: 14px;
  color: #666;
  margin: 0;
}
@media (max-width: 767px) {
  .stat-num {
    font-size: 18px;
  }
}
</style>
